import React from 'react';
import { connect } from 'react-redux';
import { list2 } from '~/actions/customersNew';
import Tag from '~/components/Tag';
import { Button, IconButton } from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';
import styleDialog from '~/style/dialog.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      results: [],
      query: ''
    };
  }

  componentDidMount() {
    this.search();
  }

  search() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query, null)
      .then(r => this.setState({
        results: r.data.results,
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }));
  }

  searchMore() {
    this.setState({ loading: true });
    list2(this.props.dispatch, this.context.apiClient, this.state.query, this.state.skipId)
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }));
  }

  renderResults() {
    if (!this.state.results || this.state.results.length === 0) {
      return (<div><span>No customers found</span></div>);
    }

    return this.state.results.map((item) => (<div key={item.id}>
      <Tag
        type="customer"
        id={item.id}
        key={item.id}
        style={{ margin: '5px 5px 0 0' }}
        onClick={() => {
          this.props.data.onChange(item.id);
          this.context.dialogClose(this.props.dialogId);
        }}
      />
    </div>));
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <div>Pick a customer</div>
            <form onSubmit={e => { e.preventDefault(); this.search(); }}>
              <Input
                type="text"
                label="Search First Name, Last Name, Company, Id, SKU"
                value={this.state.query}
                onChange={v => this.setState({ query: v, skipId: null })}
              />
              <Button label="Find" primary raised type="submit" />
            </form>
            <br />
            <div style={{ overflow: 'auto', maxHeight: '50vh' }}>
              {this.renderResults()}
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                {!this.state.loading && this.state.more && <Button label="More" primary raised onClick={() => this.searchMore()} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/CustomersNewPick/index.js